<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12" class="pt-0">
      <v-row justify="space-between">
        <v-col cols="6">
          <h1>Клиенты</h1>
        </v-col>
        <v-col cols="3" class="search-col">
          <v-text-field
                  v-model="search"
                  prepend-icon="mdi-magnify"
                  label="Поиск"
                  single-line
                  otlined
                  hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="text-right">
          <v-btn @click.stop.prevent="settingsModal = !settingsModal" class="v-btn btn-primary mr-2">Настройки</v-btn>
          <v-btn @click.stop.prevent="csv" class="v-btn btn-primary">Excel</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3" class="" style="min-height: 60px;">
          <template v-if="selected.length > 0">
          <v-btn class="mr-3" :disabled="selected.length === 0" outlined>Выбрано: {{ selected.length }}</v-btn>
          <v-menu offset-y left :disabled="selected.length === 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined
                     :disabled="selected.length === 0"
                     class="pl-0 pr-0"
                     min-width="36"
                     v-bind="attrs"
                     v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="bonusDialog = true">
                <v-list-item-title>Начислить бонусы</v-list-item-title>
              </v-list-item>
              <v-list-item @click="blockedPromocode = false; promocodeDialog = true">
                <v-list-item-title>Отправить промокод</v-list-item-title>
              </v-list-item>
              <v-list-item @click="blockedPromocode = true; promocodeDialog = true">
                <v-list-item-title>Заблокировать промокод</v-list-item-title>
              </v-list-item>
<!--              <v-list-item @click="submitDialog = true; submitItem = null">-->
<!--                <v-list-item-title>Удалить</v-list-item-title>-->
<!--              </v-list-item>-->
            </v-list>
          </v-menu>
          </template>
        </v-col>
        <v-col cols="12" sm="9" >
          <v-slide-group class="text-right">
            <v-slide-item v-if="filters.app.value ">
              <v-chip
                  class="v-btn ml-3"
                  close
                  @click:close="filters.app.value = null"
                  color="#FAFCFF"
                  outlined
                  label
                  text-color="currentColor"
              >
                {{ filters.app.value }}
              </v-chip>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет клиентов"
              no-results-text="По заданному запросу ничего не найдено"
              v-model="selected"
              :headers="finalHeaders"
              :items="users"
              :search="search"
              :options.sync="options"
              :item-class="getItemClass"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :server-items-length="totalUsers"
              :loading="loading"
              :items-per-page="15"
              loading-text="Загрузка клиентов... Подождите пожалуйста"
              show-select
      >
        <template v-slot:header.first_open_app>
          Приложение<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.app.value}"
                 @click.stop.prevent="filters.app.modal = !filters.app.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.orders_sum>
          Сумма заказов<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.orders_sum.value}"
                 @click.stop.prevent="filters.orders_sum.modal = !filters.orders_sum.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.orders_count>
          Кол-во заказов<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.orders_count.value}"
                 @click.stop.prevent="filters.orders_count.modal = !filters.orders_count.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>


        <template v-slot:header.created_at>
          Дата регистрации<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.created_at.value}"
                 @click.stop.prevent="filters.created_at.modal = !filters.created_at.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.first_order_at>
          Первый заказ<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.first_order_at.value}"
                 @click.stop.prevent="filters.first_order_at.modal = !filters.first_order_at.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.last_buy_at>
          Последний заказ<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.last_buy_at.value}"
                 @click.stop.prevent="filters.last_buy_at.modal = !filters.last_buy_at.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:header.blocked>
          Заблокирован<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.blocked.value === true || filters.blocked.value === false}"
                 @click.stop.prevent="filters.blocked.modal = !filters.blocked.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>

        <template v-slot:header.no_cash_payment>
          Без налички<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.no_cash_payment.value === true || filters.no_cash_payment.value === false}"
                 @click.stop.prevent="filters.no_cash_payment.modal = !filters.no_cash_payment.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>


        <template v-slot:header.cashback>
          % кешбека<br>
          <v-btn fab x-small outlined class="filter-button" :class="{active: filters.cashback.value}"
                 @click.stop.prevent="filters.cashback.modal = !filters.cashback.modal">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9.5" fill="white" stroke="#EAF0F6"/>
              <path d="M8.88889 13.6667H11.1111V12.5556H8.88889V13.6667ZM5 7V8.11111H15V7H5ZM6.66667 10.8889H13.3333V9.77778H6.66667V10.8889Z" fill="#B4BDC6"/>
            </svg>
          </v-btn>
        </template>
        <template v-slot:item.tg_id="{ item }">
          <a :href="getPhone(item.phone)" v-if="item.tg_id" target="_blank">link</a>
        </template>
        <template v-slot:item.orders_sum="{ item }">
          {{ item.orders_sum ? item.orders_sum : 0 }} UAH
        </template>
        <template v-slot:item.first_open_app="{ item }">
          <v-checkbox v-model="item.first_open_app" disabled :label="item.app_version" dense class="mt-0 pt-0"></v-checkbox>
        </template>
        <template v-slot:item.cashback="{ item }">
          {{ item.cashback }}%
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ formatDate(item.created_at) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click.stop="$router.push({ name: 'user-edit', params: { id: item.id } })">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-dialog
        v-model="submitDialog"
        max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
              @click="removeUser(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
              outlined
              @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="bonusDialog"
            max-width="445"
    >
      <v-card>
        <v-card-title class="headline">
          Начислить бонусы
        </v-card-title>

        <v-card-text>
          <v-text-field
                  outlined
                  v-model="bonus.count"
                  label="Количество"
          ></v-text-field>
          <v-textarea
                  outlined
                  v-model="bonus.description"
                  label="Описание"
          ></v-textarea>
        </v-card-text>

        <v-card-actions>
          <v-btn
                  :loading="loadingButton"
                  @click="giveBonuses"
          >
            Начислить
          </v-btn>
          <v-btn
                  outlined
                  @click="bonusDialog = false"
          >
            Отменить
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="promocodeDialog"
            max-width="445"
    >
      <v-card>
        <v-card-title class="headline">

          {{blockedPromocode ? 'Заблокировать' : 'Отправить'}} промокод
        </v-card-title>

        <v-card-text>
          <v-select
                  :items="promocodes"
                  :item-text="promocode => promocode.code"
                  :item-value="promocode => promocode.id"
                  v-model="currentPromocode"
                  outlined
          ></v-select>
        </v-card-text>

        <v-card-actions>
          <v-btn
                  :loading="loadingButton"
                  @click="sendPromocode"
          >
            {{blockedPromocode ? 'Заблокировать' : 'Начислить'}}
          </v-btn>
          <v-btn
                  outlined
                  @click="promocodeDialog = false"
          >
            Отменить
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="filters.app.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-select
              label="Источник"
              :items="apps"
              v-model="filters.app.tempValue"
              outlined>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setAppFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.app.modal = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="filters.orders_sum.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                  label="От"
                  outlined
                  v-model="filters.orders_sum.tempValueFrom"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                  label="До"
                  outlined
                  v-model="filters.orders_sum.tempValueTo"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setAppFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.orders_sum.modal = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
        v-model="filters.cashback.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                  label="От"
                  outlined
                  v-model="filters.cashback.tempValueFrom"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                  label="До"
                  outlined
                  v-model="filters.cashback.tempValueTo"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setAppFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.cashback.modal = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
        v-model="filters.orders_count.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                  label="От"
                  outlined
                  v-model="filters.orders_count.tempValueFrom"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                  label="До"
                  outlined
                  v-model="filters.orders_count.tempValueTo"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setAppFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.orders_count.modal = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
        v-model="filters.created_at.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-dialog
                  ref="createdAtValueFromModal"
                  v-model="filters.created_at.valueFromModal"
                  :return-value.sync="filters.created_at.tempValueFrom"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.created_at.tempValueFrom"
                      label="От"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.created_at.tempValueFrom"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.created_at.valueFromModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueFromModal.save(filters.created_at.tempValueFrom  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                  ref="createdAtValueToModal"
                  v-model="filters.created_at.valueToModal"
                  :return-value.sync="filters.created_at.tempValueTo"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.created_at.tempValueTo"
                      label="От"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.created_at.tempValueTo"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.created_at.valueToModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueToModal.save(filters.created_at.tempValueTo  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setAppFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.created_at.modal = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
        v-model="filters.first_order_at.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-dialog
                  ref="createdAtValueFromModal"
                  v-model="filters.first_order_at.valueFromModal"
                  :return-value.sync="filters.first_order_at.tempValueFrom"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.first_order_at.tempValueFrom"
                      label="От"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.first_order_at.tempValueFrom"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.first_order_at.valueFromModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueFromModal.save(filters.first_order_at.tempValueFrom  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                  ref="createdAtValueToModal"
                  v-model="filters.first_order_at.valueToModal"
                  :return-value.sync="filters.first_order_at.tempValueTo"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.first_order_at.tempValueTo"
                      label="От"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.first_order_at.tempValueTo"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.first_order_at.valueToModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueToModal.save(filters.first_order_at.tempValueTo  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setAppFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.first_order_at.modal = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="filters.blocked.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-checkbox
                  v-model="filters.blocked.tempValue"
                  label="Заблокирован"
                  v-bind="attrs"
                  v-on="on"
                  outlined
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setBlocked">Выбрать</v-btn>
          <v-btn
              outlined
              @click.prevent.stop="clearBlocked"
          >
            Очистить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="filters.no_cash_payment.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-checkbox
                  v-model="filters.no_cash_payment.tempValue"
                  label="Нельзя расплачиваться наличкой"
                  v-bind="attrs"
                  v-on="on"
                  outlined
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setNCP">Выбрать</v-btn>
          <v-btn
              outlined
              @click.prevent.stop="clearNCP"
          >
            Очистить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
        v-model="filters.last_buy_at.modal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Фильтрация
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-dialog
                  ref="createdAtValueFromModal"
                  v-model="filters.last_buy_at.valueFromModal"
                  :return-value.sync="filters.last_buy_at.tempValueFrom"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.last_buy_at.tempValueFrom"
                      label="От"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.last_buy_at.tempValueFrom"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.last_buy_at.valueFromModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueFromModal.save(filters.last_buy_at.tempValueFrom  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col>
              <v-dialog
                  ref="createdAtValueToModal"
                  v-model="filters.last_buy_at.valueToModal"
                  :return-value.sync="filters.last_buy_at.tempValueTo"
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="filters.last_buy_at.tempValueTo"
                      label="От"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="filters.last_buy_at.tempValueTo"
                    scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="filters.last_buy_at.valueToModal = false"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="$refs.createdAtValueToModal.save(filters.last_buy_at.tempValueTo  )"
                  >
                    Выбрать
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="setAppFilter">Выбрать</v-btn>
          <v-btn
              outlined
              @click="filters.last_buy_at.modal = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
        v-model="settingsModal"
        max-width="444"
    >
      <v-card>
        <v-card-title>
          Настройки
        </v-card-title>
        <v-card-text>
          <v-checkbox v-for="head in headers" :label="head.text || '...'" v-model="settings[head.value]" :key="head.value" @change="updateSetting(head.value)" >
          </v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-btn @click.prevent.stop="settingsModal = false">Продолжить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import UserService from './../../api/UserService'
  import PromocodeService from "../../api/PromocodeService";

  import moment from 'moment'

  const appNotPicked = 'Не выбрано';

  export default {
    name: 'UserIndex',
    components: {},
    data: () => ({
      tab: 1,
      loadingButton: false,
      bonusDialog: false,
      promocodeDialog: false,
      blockedPromocode: false,
      massTagDialog: false,
      massSelectedTag: {},
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      settings: {},
      settingsModal: false,
      selected: [],
      apps: [appNotPicked, 'Android', 'IOS', 'Есть приложение', 'Без приложения'],
      filters: {
        app: {
          value: '',
          tempValue: '',
          modal: false,
        },
        orders_sum: {
          valueFrom: '',
          tempValueFrom: '',
          valueTo: '',
          tempValueTo: '',
          modal: false,
        },
        orders_count: {
          valueFrom: '',
          tempValueFrom: '',
          valueTo: '',
          tempValueTo: '',
          modal: false,
        },
        cashback: {
          valueFrom: '',
          tempValueFrom: '',
          valueTo: '',
          tempValueTo: '',
          modal: false,
        },
        last_buy_at: {
          valueFrom: '',
          tempValueFrom: '',
          valueTo: '',
          tempValueTo: '',
          modal: false,
        },
        first_order_at: {
          valueFrom: '',
          tempValueFrom: '',
          valueTo: '',
          tempValueTo: '',
          modal: false,
        },
        created_at: {
          valueFrom: '',
          tempValueFrom: '',
          valueTo: '',
          tempValueTo: '',
          modal: false,
        },
        blocked: {
          value: '',
          tempValue: '',
          modal: false,
        },
        no_cash_payment: {
          value: '',
          tempValue: '',
          modal: false,
        },
      },
      bonus: {
        count: '',
        description: '',
      },
      overlay: false,
      search: '',
      loading: true,
      tags: [],
      timeRequest: null,
      submitDialog: false,
      submitItem: null,
      currentPromocode: null,
      promocodes: [],
      options: {},
      footerProps: {
        itemsPerPageText: 'Блюд на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [15, 30]
      },
      totalUsers: 0,
      finalHeaders: [],
      headers: [
        {
          text: 'ID',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Telegram',
          value: 'tg_id',
          sortable: true
        },
        {
          text: 'Телефон',
          value: 'phone',
          sortable: false
        },
        {
          text: 'Клиент',
          value: 'name',
        },
        {
          text: 'Основной адрес',
          value: 'main_address.address',
        },
        {
          text: 'Приложение',
          value: 'first_open_app',
          sortable: false,
        },
        {
          text: 'День рождения',
          value: 'birthday',
        },
        {
          text: 'Сумма заказов',
          value: 'orders_sum',
        },
        {
          text: 'Кол-во заказов',
          value: 'orders_count',
        },
        {
          text: '% кешбека',
          value: 'cashback',
        },
        {
          text: 'Дата регистрации',
          value: 'created_at',
        },
        {
          text: 'Заблокирован',
          value: 'blocked',
        },
        {
          text: 'Без налчики',
          value: 'no_cash_payment',
        },
        {
          text: 'Первый заказ',
          value: 'first_order_at',
        },
        {
          text: 'Последний заказ',
          value: 'last_buy_at',
        },
        {
          text: 'Комментарий',
          value: 'comment',
          sortable: false
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          value: 'actions',
          sortable: false,
          width: "5%"
        },
      ],
      users: [],
      categories: [],
    }),
    mounted() {
      let params = {
        available: true
      }
      PromocodeService.list(params).then(response => {
        this.promocodes = response.data.data
      })

      UserService.getSettings('users').then(response => {
        this.settings = response.data;

        for (const head of this.headers) {
          if (!this.settings.hasOwnProperty(head.value)) {
            this.settings[head.value] = true;
          }
        }

        this.updateHeaders();
      });
    },
    watch: {
      options: {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      },
      search() {
        clearTimeout(this.timerId)
        this.timerId = setTimeout(() => {
          this.getDataFromApi()
        }, 700)
      }
    },
    methods: {
      getPhone(phone) {
        let ph = phone;

        if (!ph) return '';

        if (ph.length <= 10) {
          ph = '+38' + ph;
        }

        if (ph[0] !== '+') {
          ph = '+' + ph;
        }

        return 'https://t.me/' + ph;
      },
      updateHeaders() {
        // console.log(this.headers);
        this.finalHeaders = this.headers.filter(item => !this.settings.hasOwnProperty(item.value) || this.settings[item.value]);
        // console.log(this.finalHeaders);
        // this.finalHeaders = this.headers;
      },
      updateSetting(key) {
        UserService.setSettings('users', this.settings);

        this.updateHeaders();
      },
      getItemClass(item) {
        if (item.is_removed) {
          return 'removed-row'
        }
      },
      formatDate(date) {
        return moment(date).utc().format('YYYY-MM-DD HH:mm:ss');
      },
      clearBlocked(e) {
        this.filters.blocked.tempValue = '';
        this.setAppFilter(e);
      },
      setBlocked(e) {
        if (!this.filters.blocked.tempValue) {
          this.filters.blocked.tempValue = false;
        }
        this.setAppFilter(e);
      },
      clearNCP(e) {
        this.filters.no_cash_payment.tempValue = '';
        this.setAppFilter(e);
      },
      setNCP(e) {
        if (!this.filters.no_cash_payment.tempValue) {
          this.filters.no_cash_payment.tempValue = false;
        }
        this.setAppFilter(e);
      },
      setAppFilter(e) {
        //app
        if (this.filters.app.tempValue === appNotPicked) {
          this.filters.app.tempValue = null;
        }

        this.filters.app.value = this.filters.app.tempValue
        this.filters.app.modal = false;

        //orders_sum, cashback, orders_count
        for (const key of ['orders_sum', 'cashback', 'orders_count']) {
          if (this.filters[key].tempValueFrom !== '') {
            this.filters[key].valueFrom = +this.filters[key].tempValueFrom;
          } else {
            this.filters[key].valueFrom = null;
          }
          if (this.filters[key].tempValueTo !== '') {
            this.filters[key].valueTo = +this.filters[key].tempValueTo;
          } else {
            this.filters[key].valueTo = null;
          }
          this.filters[key].modal = false;
        }

        //created_at, last_buy_at, first_order_at
        for (const key of ['created_at', 'last_buy_at', 'first_order_at']) {
          if (this.filters[key].tempValueFrom !== '') {
            this.filters[key].valueFrom = this.filters[key].tempValueFrom;
          } else {
            this.filters[key].valueFrom = null;
          }
          if (this.filters[key].tempValueTo !== '') {
            this.filters[key].valueTo = this.filters[key].tempValueTo;
          } else {
            this.filters[key].valueTo = null;
          }
          this.filters[key].modal = false;
        }

        this.filters.blocked.value = this.filters.blocked.tempValue;
        this.filters.blocked.modal = false;
        this.filters.no_cash_payment.value = this.filters.no_cash_payment.tempValue;
        this.filters.no_cash_payment.modal = false;

        this.getDataFromApi();
      },
      giveBonuses(){
        if(this.bonus.description == '' || this.bonus.count == 0){
          this.snackbar = true;
          this.snackbarText = 'Заполните поля';
          this.snackbarColor = 'error';
        }
        this.loadingButton = true;

        let ids = this.collectSelectedId();
        let params = {
          ids: ids,
          bonus: this.bonus
        }
        UserService.giveBonuses(params).then(response => {
            this.loadingButton = false;
            this.bonusDialog = false;
            this.snackbar = true;
            this.snackbarText = 'Бонусы успешно добавлены';
            this.snackbarColor = 'success';
        })
      },
      sendPromocode(){
        if(!this.currentPromocode){
          this.snackbar = true;
          this.snackbarText = 'Заполните поля';
          this.snackbarColor = 'error';
        }
        this.loadingButton = true;

        let ids = this.collectSelectedId();

        let params = {
          ids: ids,
          promocode_id: this.currentPromocode,
          blocked: this.blockedPromocode,
        }

        UserService.sendPromocode(params).then(response => {
          this.loadingButton = false;
          this.promocodeDialog= false;
          this.snackbar = true;
          this.snackbarText = 'Промокод отправлен';
          this.snackbarColor = 'success';
        })
      },
      collectSelectedId(){
        let ids = [];
        this.selected.forEach(function (item) {
          ids.push(item.id)
        })

        return ids;
      },
      removeUser(item){
        this.loading = true;
          UserService.remove(item.id).then(response => {
            this.getDataFromApi()
          })
      },
      csv() {

        this.loading = true;
        let params = {
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          csv: true,
          sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
          sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
          app: this.filters.app.value,
          ordersSumFrom: this.filters.orders_sum.valueFrom,
          ordersSumTo: this.filters.orders_sum.valueTo,
          ordersCountFrom: this.filters.orders_count.valueFrom,
          ordersCountTo: this.filters.orders_count.valueTo,
          cashBackFrom: this.filters.cashback.valueFrom,
          cashBackTo: this.filters.cashback.valueTo,
          createdAtFrom: this.filters.created_at.valueFrom,
          createdAtTo: this.filters.created_at.valueTo,
          lastBuyAtFrom: this.filters.last_buy_at.valueFrom,
          lastBuyAtTo: this.filters.last_buy_at.valueTo,
          firstOrderFrom: this.filters.first_order_at.valueFrom,
          firstOrderTo: this.filters.first_order_at.valueTo,
          search: this.search,
          from_admin: true,
        }

        const url = new URL('/api/users', process.env.VUE_APP_BACKEND_URL);
        for (const key of Object.keys(params)) {
          url.searchParams.append(key, params[key]);
        }

        console.log(url);
        window.open(url, '_blank').focus();
      },
      getDataFromApi() {
        this.loading = true
        this.selected = [];
        const timeRequest = new Date().getTime();
        this.timeRequest = timeRequest
        let params = {
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          sortBy: this.options.sortBy.length > 0 ? this.options.sortBy[0] : '',
          sortDesc: this.options.sortBy.length > 0 ? this.options.sortDesc[0] : '',
          app: this.filters.app.value,
          ordersSumFrom: this.filters.orders_sum.valueFrom,
          ordersSumTo: this.filters.orders_sum.valueTo,
          ordersCountFrom: this.filters.orders_count.valueFrom,
          ordersCountTo: this.filters.orders_count.valueTo,
          cashBackFrom: this.filters.cashback.valueFrom,
          cashBackTo: this.filters.cashback.valueTo,
          createdAtFrom: this.filters.created_at.valueFrom,
          createdAtTo: this.filters.created_at.valueTo,
          lastBuyAtFrom: this.filters.last_buy_at.valueFrom,
          lastBuyAtTo: this.filters.last_buy_at.valueTo,
          firstOrderFrom: this.filters.first_order_at.valueFrom,
          firstOrderTo: this.filters.first_order_at.valueTo,
          search: this.search,
          from_admin: true,
          blocked: this.filters.blocked.value,
          no_cash_payment: this.filters.no_cash_payment.value,
        }
        UserService.list(params)
          .then(response => {
            if(this.timeRequest === timeRequest){
              this.users = response.data.data.map(item => {
                item.no_cash_payment = item.no_cash_payment ? '+' : '';
                return item;
              })
              this.totalUsers = response.data.total
              this.loading = false
            }
          })
      },
    }
  }
</script>

<style>
.removed-row{
  background-color: #FFEEEC;
}
</style>


<style lang="scss" scoped>
::v-deep{
  table .v-input:not(.disabled) .v-input__slot{
    background-color: transparent;
  }
}
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
